import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';  
import './App.css';
import Header from './components/Header/Header';
import DeliveryProcess from './pages/DeliveryProcess/DeliveryProcess';

function App() {
  return (
    <div className="App">
      <Header />
      <Router>
        <Routes>
          <Route path="/:barcode" element={<DeliveryProcess />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
